import api from './client';

// Supplier payments through Wise: drafted here, paid only after approval (2026-09-27)
export const wisePayoutsAPI = {
  getStatus: () => api.get('/wise-payouts/status'),
  getSuggestions: (params) => api.get('/wise-payouts/suggestions', { params }),
  createDraft: (body) => api.post('/wise-payouts/drafts', body),
  approve: (id) => api.post(`/wise-payouts/drafts/${id}/approve`),
  cancel: (id) => api.post(`/wise-payouts/drafts/${id}/cancel`),
};
